import { IonTextarea } from "@ionic/react";
import { Asterisk, ErrorAlert } from "swing-components";

import { translate } from "~utils";

/***** Types *****/
type NotesToSubFieldProps = {
  memo: string;
  onChange: (memo: string) => void;

  formSubmissionErrObj?: Record<string | "memo", string>;
  onFormSubmissionError?: (
    error: (error: Record<string, string>) => Record<string, string> & { memo?: string },
  ) => void;
  onRequiredFieldTouched: (e: (touched: object) => { memo: boolean }) => void;
};

export function NotesToSubField(props: NotesToSubFieldProps) {
  const { memo, onChange, formSubmissionErrObj, onFormSubmissionError, onRequiredFieldTouched } =
    props;

  /*** Handlers ***/
  function handleChange(newMemo: string) {
    onChange(newMemo);

    // TODO: Future let's simplify the error states for this component.
    onRequiredFieldTouched((touched: object) => ({
      ...touched,
      memo: true,
    }));
    updateMemoErrorState(newMemo, true, onFormSubmissionError);
  }

  /*** Render ***/
  return (
    <label>
      {/* Label */}
      <div css={{ fontWeight: 500 }}>
        {translate("NOTES_TO_SUB_LABEL")}
        <Asterisk />
      </div>

      {/* Error Message */}
      {formSubmissionErrObj?.memo && (
        <ErrorAlert customStyles={{ alignItems: "center", fontWeight: 400 }}>
          <span>{translate("NOTES_TO_SUB_REQ_MEMO_ERROR")}</span>
        </ErrorAlert>
      )}

      {/* Textarea */}
      <IonTextarea
        aria-label={translate("NOTES_TO_SUB_LABEL")}
        value={memo}
        onIonInput={(e) => handleChange(e.detail.value ?? "")}
        onIonBlur={() => updateMemoErrorState(memo, true, onFormSubmissionError)}
        placeholder={translate("NOTES_TO_SUB_PLACEHOLDER")}
        autoGrow
      />
    </label>
  );
}

/***** Helper Functions *****/
function updateMemoErrorState(
  memo: string,
  isMemoTouched: boolean,
  onFormSubmissionError: NotesToSubFieldProps["onFormSubmissionError"],
) {
  onFormSubmissionError?.((error) => ({
    ...error,
    memo: memo.trim() === "" && isMemoTouched ? translate("NOTES_TO_SUB_REQ_MEMO_ERROR") : "",
  }));
}
